<div class="thank-you-container">
  <div class="thank-you-card" id="printable-card">
    <h1 class="thank-you-title">Thank You!</h1>
    <p class="thank-you-message">Your payment has been processed.</p>
    
    <div class="order-info">
      <div class="info-row">
        <span class="info-label">Order ID:</span>
        <span class="info-value">{{ orderId || 'N/A' }}</span>
      </div>
      <div class="info-row">
        <span class="info-label">Status:</span>
        <span class="info-value">{{ status || 'N/A' }}</span>
      </div>
    </div>
 
    <div class="print-button-container">
      <button class="print-button" (click)="printReceipt()">
        <span class="print-icon">🖨️</span>
        Print Receipt
      </button>
    </div>
  </div>
</div>
